import { useAtom } from "jotai";
import { pricingReturnPathAtom } from "../store/pricing-return-path.store";
import type { IUseCheckoutRedirectUrl } from "./useCheckoutRedirectUrl.interface";

const DEFAULT_RETURN_PATH = "/profile";

export function useCheckoutRedirectUrl(): IUseCheckoutRedirectUrl {
  const [pricingReturnPath, setPricingReturnPath] = useAtom(pricingReturnPathAtom);

  // location.state.from is a generic navigation breadcrumb (sidebar, header, back-nav):
  // only the persisted path written by upgrade flows may drive the checkout return url.
  function resolveCheckoutRedirectHref(): string {
    const path = pricingReturnPath ?? DEFAULT_RETURN_PATH;
    return new URL(path, window.location.origin).href;
  }

  function clearPricingReturnPath(): void {
    setPricingReturnPath(null);
  }

  return {
    setPricingReturnPath,
    resolveCheckoutRedirectHref,
    clearPricingReturnPath,
  };
}
